<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer">
      <div class="appraisal-center fonts marr">
        <el-tabs class="on_tous_sdas" v-model="resultMode" @tab-click="handleTabClick">
          <el-tab-pane label="职业性格设置" name="jzjg"></el-tab-pane>
          <el-tab-pane label="职业性格详情设置" name="xgjg"></el-tab-pane>
        </el-tabs>
        <template v-if="resultMode=='jzjg'">
          <div>
            <span>维度：</span>
            <span>
            <el-tag
                v-if="item.name != '综合'"
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
          </div>
          <div style="margin-top: 20px">
            <el-button type="success" size="small" @click="handleClick('add')"
            >添加结果<i class="el-icon-plus"></i
            ></el-button>
            <span class="subject"
            >共 <i>{{emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
                emptyShow(getWDData[tagIndex]).maxScore
              }}</i
            >分
          </span>
          </div>
          <div style="margin-top: 20px">
            <div class="public-table-data">
              <el-table
                  ref="multipleTable"
                  size="medium"
                  :data="getWdResulData"
                  border
                  style="width: 100%"
                  row-key="menuId"
                  v-loading="loading"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    width="80"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="minScore"
                    label="最小值"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="maxScore"
                    label="最大值"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="descr"
                    label="解析"
                    min-width="400"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div v-html=" $options.filters.ellipsis(scope.row.descr) "
                         style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="suggest"
                    label="建议"
                    min-width="400"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div v-html=" $options.filters.ellipsis(scope.row.suggest) "
                         style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="240"
                >
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleClick('edit', scope.row)"
                        type="primary"
                        plain
                    >编辑
                    </el-button
                    >
                    <el-button
                        v-if="scope.$index<=4 && detalisObj.examId=='LHXG'"
                        size="mini"
                        @click="conditionClick(scope.row)"
                        type="success"
                        plain
                    >条件
                    </el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleDelete(scope.row)"
                        type="danger"
                        plain
                        v-if="numType"
                    >删除
                    </el-button
                    >
                    <el-button
                        v-else
                        size="mini"
                        @click="operationShowTime"
                        type="danger"
                        plain
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
        <template v-if="resultMode=='xgjg'">
          <div class="topic-outer conteny_dsd" v-loading="loading" style="padding-bottom: 30px">
            <el-empty description="暂无数据" v-if="noContentJz"></el-empty>
            <div v-else class="appraisal-center fonts marr">
              <template v-if="initJZData">
                <el-tabs
                    tab-position="left"
                    v-model="activeName"
                    @tab-click="handleChangClick"
                >
                  <el-tab-pane
                      v-for="item in initJZData"
                      :key="item.examResultId"
                      :label="item.code"
                      :name="item.examResultId.toString()"
                  >
                  </el-tab-pane>
                  <div>
                    <div class="public-dialog-form">
                      <el-form
                          ref="ruleForm"
                          :rules="contentrules"
                          :model="contentParams"
                          label-width="110px"
                      >
                        <el-row>
                          <el-col :span="18">
                            <el-form-item label="说明" prop="content">
                              <rich-text v-if="innerVisible" :keyWord="'content'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="专业分析" prop="descr">
                              <rich-text v-if="innerVisible" :keyWord="'descr'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                      <span slot="footer" class="public-dialog-footer">
                <el-button size="medium" @click="handleContentEdit('reset')">
                  重 置</el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="handleContentEdit('add')"
                >提 交</el-button
                >
              </span>
                    </div>
                  </div>
                </el-tabs>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="维度">
            <div>{{ resue.name }}</div>
          </el-form-item>
          <el-form-item label="分值" prop="minScore">
            <el-input
                placeholder="请填最低分值"
                v-model="params.minScore"
                style="width: 262px"
                type="number"
            ></el-input>
            -
            <el-input
                type="number"
                placeholder="请填最高分值"
                v-model="params.maxScore"
                style="width: 262px"
            ></el-input>
          </el-form-item>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="解析" prop="descr">
            <rich-text v-if="innerVisible" :keyWord="'descr'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="专业推荐" prop="suggest2">
            <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 8 }"
                placeholder="请填写主题"
                v-model="params.suggest2"
            >
            </el-input>
            <div>输入格式为“学科|专业1，专业2”，以“|”拆分为列。</div>
          </el-form-item>
          <el-form-item label="建议" prop="suggest">
            <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="主性格" prop="content">
            <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="副性格" prop="guideSuggest">
            <rich-text v-if="innerVisible" :keyWord="'guideSuggest'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="从性格" prop="title">
            <rich-text v-if="innerVisible" :keyWord="'title'" :params="params?params:''"></rich-text>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="条件设置"
        :visible.sync="conditionDialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form_tans">
        <div class="title_dun_dime">解析条件</div>
        <div class="title_dun_dime">动物：<span v-html="conditionInfo.title"></span></div>
        <div class="dimension_box">
          <div class="dimension_box_title">维度组合：</div>
          <div class="dimension_box_lis">
            <div class="dimension_content_list" v-for="(item,index) in conditionWDData" :key="index">
              <div class="dimension_title_info">{{ item.name }}</div>
              <template>
                <el-radio-group v-model="item.checkRadio">
                  <el-radio :label="1">高</el-radio>
                  <el-radio :label="0">低</el-radio>
                </el-radio-group>
              </template>
            </div>
            <el-button class="button_bottom" size="medium" type="primary" @click="addCondition">确定</el-button>
            <el-table
                :data="listCondition"
                border
                row-key="menuId"
                v-loading="loading"
                style="width: 100%;margin: 20px 0">
              <el-table-column
                  prop="date"
                  label="序号"
                  align="center"
                  width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="conditionName"
                  label="维度组合"
                  align="center"
                  width="350">
              </el-table-column>
              <el-table-column
                  prop="address"
                  label="操作"
                  align="center"
                  width="100"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      plain
                      @click="deleteCondition(scope.row)"
                      v-if="numType"
                  >删除
                  </el-button
                  >
                  <el-button
                      size="mini"
                      plain
                      v-else
                      @click="operationShowTime"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <operation-confirmation @closeOperation="publicMethios"
                            :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>

import {isEmpty, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import OperationConfirmation from "../../../components/OperationConfirmation";
import richText from "../../../components/richText";

export default {

  filters: {
    //当渲染的文字超出30字后显示省略号
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 60) {
        return value.slice(0, 60) + "...";
      }
      return value;
    }
  },
  data() {
    return {
      //灵魂条件
      isMoer: true,
      srcList: [],
      conditionDialogVisible: false,
      conditionWDData: [],
      conditionInfo: {},
      listCondition: [],
      //之前的代码
      emptyShow, isEmpty,
      detalisObj: {},
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {},
      loading: false,
      dialogVisible: false,
      params: {
        icon: ''
      },
      clickType: "",
      rules: {
        minScore: [
          {
            required: true,
            message: "请填写正确的分值",
            trigger: "blur",
          },
        ],
      },
      operationVisible: false,
      numType: false,
      innerVisible: false,
      resultMode: 'jzjg',
      noContentJz: false,
      activeName: "",
      initJZData: [],
      contentParams: {},
      contentrules: {},
    };
  },
  components: {
    OperationConfirmation,
    richText
  },
  computed: {
    conditionKey() {
      let arr = []
      if (this.detalisObj.examId == 'LHXG') {
        if (this.conditionWDData.length) {
          this.conditionWDData.map(item => {
            let obj_txt = item.code + '-' + item.checkRadio
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    },
    conditionName() {
      let arr = []
      if (this.detalisObj.examId == 'LHXG') {
        if (this.conditionWDData.length) {
          this.conditionWDData.map(item => {
            let obj_txt = item.name + (item.checkRadio == 1 ? '(高)' : '(低)')
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.innerVisible = false
      }
    },
  },
  created() {
    this.getAppraisalData();
    this.getWDList();
  },
  methods: {
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;
      const {data: resData} = await this.$post(
          `exam/result/init/datum/${this.$route.query.examId}`
      );

      if (resData.result != 200) {
        this.loading = false;
        return;
      } else {
        this.loading = false;
        if (resData.data) {
          this.noContentJz = false
          this.jzIsShow = false;
          this.jzIsHiden = true;
          resData.data.map(item => {
            item.examResultContent = item.code
          })
          this.initJZData = resData.data;
          let id = resData.data[0].examResultId;
          this.activeName = id.toString();
          this.params.examResultId = id;
          this.resultDetails(id);
        } else {
          this.noContentJz = true
          this.initJZData = []
        }
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(
          `exam/result/info/${examResultId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.srcList = []
      this.isMoer = true
      if (resData.data) {
        if (resData.data.icon) {
          this.srcList.push(resData.data.icon)
          this.isMoer = false
        }
        this.contentParams = resData.data;
        this.innerVisible = true
      } else {
        this.contentParams = {}
        this.innerVisible = true
      }
    },

    handleContentEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.contentParams,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
          })
        });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.contentParams = {}
          this.$message.success("重置成功!");
        })
      }
    },
    handleChangClick(tab, event) {
      this.innerVisible = false
      this.srcList = []
      this.isMoer = true
      this.shareSrcList = []
      this.shareIsMoer = true
      this.$refs.ruleForm.resetFields();
      this.contentParams = {}
      this.contentParams.examResultId = parseInt(tab.name);
      this.resultDetails(tab.name);
    },
    handleTabClick() {
      if (this.resultMode == 'jzjg') {
        this.getWDList()
      } else {
        this.initJZ()
      }
      this.srcList = []
      this.isMoer = true
      this.shareSrcList = []
      this.shareIsMoer = true
      this.params = {}
      this.contentParams = {}
      this.innerVisible = false
    },


    //清楚缓存数据，重启密码验证
    clearStore() {
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e) {
      this.operationVisible = false
      if (e == 'open') {
        this.numType = true
        setTimeout(() => {
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        }, 1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true
    },
    //添加条件
    async addCondition() {
      let params = {
        conditionKey: this.conditionKey,
        conditionName: this.conditionName,
        examResultId: this.conditionInfo.examResultId,
      }
      this.loading = true;
      const {data: resData} = await this.$post(
          `exam/result/condition/info`, params);
      this.loading = false;
      if (resData.result != 200) {
        this.$message.error(resData.message)
        return
      }
      this.getConditionList(this.conditionInfo.examResultId)
    },
    //删除条件
    async deleteCondition(e) {
      this.$confirm("此操作将永久删除该测评题库数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.loading = true;
        const {data: resData} = await this.$delete(
            `exam/result/condition/info/${e.examResultConditionId}`);
        if (resData.result != 200) return;
        this.getConditionList(this.conditionInfo.examResultId)
        this.$message.success("删除成功!");
      }).catch(() => {

      });
      this.clearStore()
    },
    //点击列表条件弹框
    async conditionClick(e) {
      this.conditionInfo = e
      this.conditionWDData = []
      this.getConditionList(e.examResultId)
      let arr = this.getWDData
      arr.map((item, index) => {
        if (index != 0) {
          let obj = {
            name: item.name,
            checkRadio: 1,
            examDimensionId: item.examDimensionId,
            examInfoId: item.examInfoId,
            code: item.code,
          }
          this.conditionWDData.push(obj)
        }
      })
      this.conditionDialogVisible = true
    },
    //获取到条件列表
    async getConditionList(e) {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/result/condition/list`, {
            params: {
              examResultId: e
            }
          }
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.listCondition = resData.data;
    },
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );

      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
      this.isMoer = false;
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        resData.data.map(item => {
          if (item.name != '综合') {
            this.getWDData.push(item)
          }
        })
      }
      this.resue = {
        code: this.getWDData[this.tagIndex].code,
        name: this.getWDData[this.tagIndex].name,
      };
      this.getWdResultList(this.resue.code); //初始化表格
    },
    /**
     * 获取测评维度j结果列表
     */
    async getWdResultList(examDimensionCode) {
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}
      if (emptyShow(examDimensionCode)) {
        temp.examDimensionCode = examDimensionCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (emptyShow(resData.data)) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
    },
    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      this.tagIndex = index;

      this.params.examDimensionCode = code;
      this.getWdResultList(code);
      this.resue = {
        name,
        code,
      };
    },
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.innerVisible = false
      if (type == "add") {
        this.params = {};
        this.srcList = []
        this.innerVisible = true
        this.dialogVisible = true;
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        this.dialogVisible = true;
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true
        this.srcList = []
        if (resData.data.icon) {
          this.srcList.push(resData.data.icon)
        }
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      if (Number(this.params.minScore) > Number(this.params.maxScore)) {
        this.$message.error('最小值不能大于最大值')
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.examDimensionCode = this.resue.code;
            this.params.examId = this.$route.query.examId;
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.getWdResultList(this.resue.code);
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
            this.innerVisible = false
          } else {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code);
            this.dialogVisible = false;
            this.$message.success("修改成功!");
            this.innerVisible = false
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.code);
      });
      this.clearStore()
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 100%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.public-dialog-form_tans {
  .title_dun_dime {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .dimension_box {
    display: flex;

    .dimension_box_lis {
      .dimension_content_list {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .dimension_title_info {
          width: 80px;
          text-align: right;
          margin-right: 10px;
        }
      }

      .button_bottom {
        margin-top: 20px;
        margin-left: 80px;
      }
    }
  }
}
</style>

<style lang="scss">
  .conteny_dsd{
    .appraisal-center{
      .el-tabs--left .el-tabs__header.is-left{
        height: 50vh;
      }
    }
  }
</style>